/**
 * The "is this browser signed in with a verified account" signal.
 *
 * `email_verified_at` in localStorage is a non-sensitive UX marker (the real
 * auth is the httpOnly cookie, enforced server-side). It is written from
 * `data?.email_verified_at`, so an unverified account used to store the literal
 * STRING "null" (and a missing field the string "undefined") — both truthy, so
 * every guard that did `if (localStorage.getItem("email_verified_at"))` treated
 * an unverified user as signed in. Every reader must go through here.
 */
const EMPTY = new Set(['', 'null', 'undefined', 'false', '0']);

export const isVerifiedValue = (v) => v != null && !EMPTY.has(String(v).trim());

export function hasVerifiedSession() {
  try {
    return isVerifiedValue(localStorage.getItem('email_verified_at'));
  } catch {
    return false;
  }
}
